<div mat-dialog-content>
      <form [formGroup]="rankGroup">
        <br>
        <ng-template matStepLabel>Select Rank</ng-template>
        <mat-form-field>
          <mat-label>Rank</mat-label>
          <mat-select formControlName="firstCtrl" multiple>
            <mat-option *ngFor="let rank of ranks" [value]="rank.id">
              {{rank.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button (click)="save()" color="primary" mat-button>Save</button>
        </div>
      </form>
</div>
